import { Component, OnInit } from '@angular/core';
import {TooltipBaseComponent} from '../tooltip-base/tooltip-base.component';

@Component({
  selector: 'app-tooltip-channel',
  templateUrl: './tooltip-channel.component.html',
  styleUrls: ['./tooltip-channel.component.scss']
})
export class TooltipChannelComponent extends TooltipBaseComponent implements OnInit {

  ngOnInit(): void {}

}
